@if (error) {
  <mbs-alert
    class="mb-4"
    [icon]="true"
    [type]="MbsPopupType.danger">
    {{ error }}
  </mbs-alert>
}

<mbs-s3-compatible-additional-options
  [form]="form"
  [isNativeMultipartControlShown]="isNativeMultipartControlShown"
  [storageType]="StorageType.S3Compatible"></mbs-s3-compatible-additional-options>
